import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { api } from "services/api.service";
import { Pickup } from "types/pickup";
import { PickupEstimatedItem } from "types/pickupEstimatedItem";
import { PickupContact } from "types/pickupContact";
import { ActiveStorageAttachment } from "types/activeStorageAttachment";

// Later saves must win when two edits include the same fields.
let pickupSaveQueue: Promise<void> = Promise.resolve();

export function waitForPickupSaves() {
  return pickupSaveQueue;
}

export default function useUpdatePickup() {
  const params = useParams();

  interface UpdatePickupProps {
    locationId?: string;
    reason?: string;
    devicesCentralizedLocation?: boolean;
    devicesAlreadyPalletized?: boolean;
    onSitePersonPresent?: boolean;
    officeClosureDate?: string | null;
    otherVendorsOnSite?: string | null;
    devicesLeftBehind?: string | null;
    comments?: string;
    scheduledAt?: string;
    requestedTime?: string;
    estimatedItems?: PickupEstimatedItem[];
    images?: ActiveStorageAttachment[];
    contacts?: PickupContact[];
  }

  const DEFAULT_PICKUPS_ROUTE = "schedule-pickup";

  const updatePickup = useCallback(
    ({
      locationId,
      reason,
      devicesCentralizedLocation,
      devicesAlreadyPalletized,
      onSitePersonPresent,
      officeClosureDate,
      otherVendorsOnSite,
      devicesLeftBehind,
      scheduledAt,
      requestedTime,
      estimatedItems,
      images,
      contacts,
      comments,
    }: UpdatePickupProps) => {
      if (params.pickupUuid === DEFAULT_PICKUPS_ROUTE) {
        return undefined;
      }

      const request = pickupSaveQueue.then(() =>
        api.put<Pickup>(`/pickups/${params.pickupUuid}`, {
          pickup: {
            locationId,
            reason,
            devicesCentralizedLocation,
            devicesAlreadyPalletized,
            onSitePersonPresent,
            officeClosureDate,
            otherVendorsOnSite,
            devicesLeftBehind,
            scheduledAt,
            requestedTime,
            estimatedItems,
            images,
            contacts,
            comments,
          },
        })
      );

      pickupSaveQueue = request.then(
        () => undefined,
        () => undefined
      );

      return request;
    },
    [params.pickupUuid]
  );

  return {
    updatePickup,
  };
}
